export default "__VITE_ASSET__yZ5dwjOt__"